import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91e89fe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "k-match-summary" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "k-match-summary__h1" }, " Game Over ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "k-match-summary__h2" }, " But we had fun :) ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "k-match-summary__content" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "k-error-message" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "k-error-message__icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-emoji-smile" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " I had some trouble fetching your rank, but here are some fun stats from your game! ")
], -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Rounds")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Score")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Skips Used")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Hints Accepted")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Difficulty Reached")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { key: 5 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Speed ")
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Precision ")
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tap to Continue", -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode()
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-double-right ml1" }, null, -1))
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]

import * as GameTypes from 'types/game.types';
import { onMounted, reactive, ref } from 'vue';
import { useMotion, useMotions } from '@vueuse/motion'
import { useModule } from 'src/modules/modules';
import RankMeter from './rank-meter.vue';
import DottedList from 'src/components/dotted-list.vue';
import DottedListItem from 'src/components/dotted-list-item.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'match-summary',
  props: {
    context: null,
    stats: null
  },
  emits: ['next'],
  setup(__props: any, { emit }) {

const props = __props as {
    context?: 'rank' | 'best',
    /**
     * The stats data. If this component is being rendered after a game, the stats data will be pulled from the
     * game module. Otherwise, it should be passed down through props and the context should be set to 'best'
     */
    stats?: GameTypes.RankedPersistedStats
}

_useCssVars(_ctx => ({
  "79d0f004": (_unref(theme).theme.cardBg),
  "30ea7d54": (_unref(theme).theme.titleBg)
}))

const { game, theme } = useModule();




const hastePercentage = game.matchState.hasteCount / game.matchState.round;
const precisionPercentage = game.matchState.precisionCount / game.matchState.precisionRounds;

const rank = ref({
    matchRank: -1,
    overrallRank: -1
})

let statsData : GameTypes.RankedPersistedStats | false | undefined = props.context === 'best' && props.stats ? props.stats : game.requests.statsData;
if (statsData){
    rank.value = {
        matchRank: statsData.matchRank,
        overrallRank: statsData.overrallRank
    }
}

const title = ref<HTMLElement>()
const motionInstance = useMotion(title, {
    initial: {
        opacity: 0,
        y: -300
    },
    enter: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 500,
            ease: 'easeOut'
        }
    },
    leave: {
        opacity: 0,
        y: 300,
        transition: {
            duration: 500,
            ease: 'easeIn'
        },
    }
})

const tray = ref();
const trayMotion = useMotion(tray, {
    initial: {
        opacity: 0,
        y: 200
    },
    enter: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 350,
            ease: 'easeOut'
        }
    },
    leave: {
        opacity: 0,
        y: 200,
        transition: {
            duration: 350,
            ease: 'easeIn'
        },
    }
})

if (props.context === 'rank'){
    game.resetBackground();
    game.startBackgroundFx();
}

//game.setBackgroundColor(Phaser.Display.Color.HexStringToColor(theme.getTheme('default')!.gameBg));

const ready = ref(false);
const transitioning = ref(false);
const handleClick = async () => {
    if (!transitioning.value && ready.value){
        transitioning.value = true;
        await motionInstance.apply('leave');
        emit('next');
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      ref_key: "title",
      ref: title,
      class: "k-match-summary__title"
    }, _hoisted_4, 512), [
      [_vShow, __props.context === 'rank']
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_unref(statsData))
        ? (_openBlock(), _createBlock(RankMeter, {
            key: 0,
            stats: _unref(statsData),
            context: __props.context
          }, null, 8, ["stats", "context"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(DottedList, null, {
              default: _withCtx(() => [
                _createVNode(DottedListItem, null, {
                  left: _withCtx(() => [
                    _hoisted_8
                  ]),
                  right: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(game).matchState.round), 1)
                  ]),
                  _: 1
                }),
                _createVNode(DottedListItem, null, {
                  left: _withCtx(() => [
                    _hoisted_9
                  ]),
                  right: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(game).matchState.score), 1)
                  ]),
                  _: 1
                }),
                _createVNode(DottedListItem, null, {
                  left: _withCtx(() => [
                    _hoisted_10
                  ]),
                  right: _withCtx(() => [
                    _createTextVNode(_toDisplayString(5 - _unref(game).matchState.skips), 1)
                  ]),
                  _: 1
                }),
                _createVNode(DottedListItem, null, {
                  left: _withCtx(() => [
                    _hoisted_11
                  ]),
                  right: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(game).matchState.hintCount), 1)
                  ]),
                  _: 1
                }),
                _createVNode(DottedListItem, null, {
                  left: _withCtx(() => [
                    _hoisted_12
                  ]),
                  right: _withCtx(() => [
                    (_unref(game).matchState.difficulty === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Very Easy "))
                      : (_unref(game).matchState.difficulty === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Easy "))
                        : (_unref(game).matchState.difficulty === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Moderate "))
                          : (_unref(game).matchState.difficulty === 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Difficult "))
                            : (_unref(game).matchState.difficulty >= 4)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Very Difficult "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_18, " EXTREME "))
                  ]),
                  _: 1
                }),
                _createVNode(DottedListItem, null, {
                  left: _withCtx(() => [
                    _hoisted_19
                  ]),
                  right: _withCtx(() => [
                    (hastePercentage < .4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Slow "))
                      : (hastePercentage <= .6)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Moderate "))
                        : (hastePercentage <= .85)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Fast "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23, " Aggresive "))
                  ]),
                  _: 1
                }),
                _createVNode(DottedListItem, null, {
                  left: _withCtx(() => [
                    _hoisted_24
                  ]),
                  right: _withCtx(() => [
                    (hastePercentage < .4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Low "))
                      : (hastePercentage <= .6)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, " Moderate "))
                        : (hastePercentage <= .85)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, " High "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_28, " Laser "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "tray",
      ref: tray,
      class: "k-match-summary__tray"
    }, [
      _createElementVNode("button", {
        class: "k-continue-btn",
        onClick: _cache[0] || (_cache[0] = () => emit('next'))
      }, _hoisted_32)
    ], 512), [
      [_vShow, __props.context === 'rank']
    ])
  ]))
}
}

})